(function ($) {

// put stuff that is different from main theme js here
// preferably only a variable that is used in code but you could also override functions
window.vrnetworld.config.startEventScrollTarget = '#player';
window.vrnetworld.config.afterStreamShowPosterOnly = false;
window.vrnetworld.config.websocketEnabledFor.frontpage = true;

wp.hooks.addAction( 'commonInit',
function() {
    jQuery(".radio-rating").append("<div class='clear'></div>").find(">label, >div>ul>li").matchHeight(); // match form radio heights
    jQuery(".radio-yesno").append("<div class='clear'></div>").find(">label, >div>ul>li").matchHeight(); // match form radio heights
}, 10 );

wp.hooks.addFilter( 'userGetInitials',
function(display_name) {
    if (display_name.indexOf(" (") !== -1) {
        display_name = display_name.split(" (")[0];
    }
    return display_name.replace('#', '');
}, 10 );

wp.hooks.addFilter( 'netconSaveTheSessionRememberButton',
    function(current) {
        if(current.caption === "Termin vormerken") {
            current.caption = "Termin merken";
        } else {
            current.caption = "Termin gemerkt";
        }

        return current;
    }, 10
);

window.vrnetworld.comments.initComment = function () {
    $("#commentform").submit(function (e) {
        e.preventDefault();

        if(getLibObject("websocket").socket.connected) {

            // Daten aus dem Form laden
            var counter = $('.char-counter');
            var messageTextfield = $('#comment');
            var messageTextfieldText = messageTextfield.val().trim();
            if(messageTextfieldText === "") {
                messageTextfield.val('');
                counter.text('0/250');
                return false;
            }
            var sendToNode = {
                blogId: sage_js.blog_id,
                sessionId: ajax_variables.post_id,
                message: window.vrnetworld.comments.replaceEmoji(messageTextfieldText)
            };

            getLibObject("websocket").socket.emit('frontend-comment-submit', sendToNode, function (response) {
                getLibObject("helper").log(response);
            }); // Sende Event (chat message) mit dem Inhalt der Chateingabe an den Server
            messageTextfield.val('');
            counter.text('0/250');
            return false;
        } else {
            $.growl.error($.extend({title: ""}, {message: "Es ist ein Fehler aufgetreten. Ihre eingetragenen Daten wurden nicht übernommen."}));
            return false;
        }
    });
};

window.vrnetworld.comments.modCommentGetOrderedAndFilteredComments = function(comments) {
    var that = getLibObject('comments');
    var commentsFiltered = comments.filter(that.modCommentFilter);
    // orders in place
    commentsFiltered.sort(that.modCommentOrder);
    return commentsFiltered;
};

window.vrnetworld.comments.modCommentOrder = function (commentA, commentB) {
    if(commentA.meta.comment_chosen > commentB.meta.comment_chosen) {
        return 1;
    }
    if(commentA.meta.comment_chosen < commentB.meta.comment_chosen) {
        return -1;
    }

    return 0;
};

window.vrnetworld.comments.modCommentUpdateDashboard = function(commentId) {
    var that = getLibObject('comments');
    var emptyEl = $("#mod-comments-empty-message");
    var comments = that.currentModComments;

    if(comments.length === 0) {
        emptyEl.show();
    } else {
        emptyEl.hide();
    }
};

window.vrnetworld.comments.modCommentUpdateDom = function(commentId,property,value) {
    var that = getLibObject('comments');
    var commentEl = $("#comment-" + commentId);
    var listEl = $("#mod-comments-list");

    // comment exists
    if(commentEl.length) {
        if(property === "comment_hot") {
            if(value) {
                commentEl.addClass("state-is-hot");
            } else {
                commentEl.removeClass("state-is-hot");
            }
        }
        if(property === "comment_stage_direction") {
            if(value) {
                commentEl.addClass("state-has-stage-direction");
                commentEl.find(".sd-content").html(getLibObject('helper').wpautop(value));
            } else {
                commentEl.removeClass("state-has-stage-direction");
                commentEl.find(".sd-content").html("");
            }
        }
        if(property === "comment_karma") {
            commentEl.find("> .item-content .comment-weight-value").html("+" + value + "&nbsp;");
        }
        if(property === "comment_content") {
            if(value !== '') {
                commentEl.find('> .item-content .comment-content').html(getLibObject('helper').wpautop(getLibObject('comments').replaceSmileys(value)));
            }
        }
    } else {
        // comment does not exist
        var comment = that.currentModComments[commentId];
        // check if comment should exist
        if(comment && that.modCommentFilter(comment)) {
            // insert
            var commentHtml = that.renderModComment(comment,getLibObject('config').ajax_templates.modComment);
            listEl.append(commentHtml);
            commentEl = $("#comment-" + commentId);
            commentEl.find(".task1").on('click', that.modCommentClickHandler );
        }
    }

    if(that.modCommentIsCommentVisible(commentId)) {
        commentEl.removeClass("hide");
    } else {
        commentEl.remove();
    }
};

})(jQuery);
